import React from 'react'

const PageNotFound = () => {
  return (
    <div className='bg-dark text-info' style={{height:'500px'}}>
        <h1 className='text-center p-5 display-1'>page not found</h1>
    </div>
  )
}

export default PageNotFound